var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row bg-grey pt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", { staticClass: "title-h3 border-bottom pb-3" }, [
            _c("button", {
              staticClass: "btn btn-back",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$router.push("/customers")
                }
              }
            }),
            _vm._v("\n        Back\n      ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "l-bg-white" }, [
        _c("div", { staticClass: "row my-3" }, [
          _vm.$_can("leads.store")
            ? _c("div", { staticClass: "col-12 text-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.toggleCreateSidebar }
                  },
                  [_vm._v("\n          Create lead\n        ")]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { autocomplete: "off" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submit($event)
              },
              keydown: function($event) {
                _vm.errors.clear()
              }
            }
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "div",
                    { staticClass: "select-wrap" },
                    [
                      _c("label", [_vm._v("Company")]),
                      _vm._v(" "),
                      _c("simple-select", {
                        attrs: {
                          options: _vm.companies,
                          placeholder: "Select Company"
                        },
                        model: {
                          value: _vm.customer.company_id,
                          callback: function($$v) {
                            _vm.$set(_vm.customer, "company_id", $$v)
                          },
                          expression: "customer.company_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "company_id" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("First name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customer.first_name,
                          expression: "customer.first_name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", autocomplete: "no" },
                      domProps: { value: _vm.customer.first_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.customer,
                            "first_name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "first_name" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Last name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customer.last_name,
                          expression: "customer.last_name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", autocomplete: "no" },
                      domProps: { value: _vm.customer.last_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.customer,
                            "last_name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "last_name" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customer.email,
                          expression: "customer.email"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "email", autocomplete: "no" },
                      domProps: { value: _vm.customer.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.customer, "email", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "email" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("div", { staticClass: "select-wrap" }, [
                    _c("label", [_vm._v("Phone")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.customer.phone,
                          expression: "customer.phone"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "Enter Phone",
                        autocomplete: "no",
                        maxlength: "14"
                      },
                      domProps: { value: _vm.customer.phone },
                      on: {
                        keydown: _vm.maskPhone,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.customer, "phone", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "phone" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.customer.contacts, function(contact, index) {
              return _c("div", { key: contact.id }, [
                index === 0
                  ? _c("div", { staticClass: "row" }, [_vm._m(0, true)])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Email")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: contact.email,
                              expression: "contact.email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "email",
                            autocomplete: "no",
                            placeholder: "Enter Email"
                          },
                          domProps: { value: contact.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(contact, "email", $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: {
                          errors: _vm.errors,
                          field: "contacts." + index + ".email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-4" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Phone")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: contact.phone,
                              expression: "contact.phone"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            autocomplete: "no",
                            placeholder: "Enter Phone",
                            maxlength: "14"
                          },
                          domProps: { value: contact.phone },
                          on: {
                            keydown: function($event) {
                              _vm.maskAdditionalPhone(index, $event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(contact, "phone", $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: {
                          errors: _vm.errors,
                          field: "contacts." + index + ".phone"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-4" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-clear p-1 mt-3",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.removeContact(index)
                          }
                        }
                      },
                      [_c("span", { staticClass: "mod-icon-clear" })]
                    )
                  ])
                ])
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn add-button",
                    attrs: { type: "button" },
                    on: { click: _vm.addAdditionalContact }
                  },
                  [
                    _vm._m(1),
                    _vm._v("\n            Add additional contact\n          ")
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-5" }, [
              _c("div", { staticClass: "col" }, [
                _vm.$_can("companies.customers.destroy")
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.remove(_vm.customer.id)
                          }
                        }
                      },
                      [_vm._v("\n            Delete\n          ")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col" }, [
                _vm.$_can("companies.customers.update")
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary float-right ld-ext-right",
                        class: _vm.loadingButton ? "running" : "",
                        attrs: { disabled: _vm.buttonDisabled }
                      },
                      [
                        _vm._v("\n            Save\n            "),
                        _c("div", { staticClass: "ld ld-ball ld-flip" })
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("error-field", {
              attrs: { errors: _vm.errors, field: "deletion" }
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.hideCreateSidebar($event)
                  }
                }
              },
              [
                _vm.showCreateSidebar
                  ? _c("leads-create", {
                      staticClass: "sidebar-right",
                      attrs: {
                        customer: _vm.customer,
                        "searching-duplicate-leads": _vm.searchingDuplicateLeads
                      },
                      on: {
                        cancel: _vm.hideCreateSidebar,
                        "leads-search": _vm.checkDuplicateLeads,
                        "leads-clear": _vm.clearDuplicateLeads
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.duplicateLeads.length
          ? _c("div", { staticClass: "duplicate-lead-wrap" }, [
              _c("h3", [
                _vm._v("Existing leads for the same customer have been found.")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "duplicate-lead-box-overflow" },
                [
                  _vm._l(_vm.duplicateLeads, function(lead) {
                    return _c(
                      "div",
                      {
                        key: lead.id,
                        staticClass: "duplicate-lead-box",
                        class: { "lead-can-access": lead.can_access === true }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            class: [
                              lead.can_access === true
                                ? "pointer"
                                : "pointer-events-none"
                            ],
                            attrs: {
                              to: "/leads/edit/" + lead.id + "?q=" + lead.ref_id
                            }
                          },
                          [
                            _c("div", { staticClass: "col-md-4 px-0 mb-0" }, [
                              _c("span", { staticClass: "refId" }, [
                                _vm._v(_vm._s(lead.ref_id))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6 px-0 mb-0" }, [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(lead.customer))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-2 px-0 mb-0 text-right" },
                              [_c("span", { staticClass: "mod-icon-arrow" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 px-0 mb-0 pt-1" },
                              [
                                _c("div", { staticClass: "input-wrap" }, [
                                  _c("label", [_vm._v("Assigned to")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        lead.cluster_user
                                          ? lead.cluster_user
                                          : "-"
                                      )
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-8 px-0 mb-0 pt-2" },
                              [
                                _c("div", { staticClass: "input-wrap" }, [
                                  _c("label", [_vm._v("Company")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(lead.company))])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-4 px-0 mb-0 pt-2 text-right"
                              },
                              [
                                lead.status
                                  ? [
                                      lead.status_id === 1 ||
                                      lead.status_id === 7
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-active" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      lead.status_id === 2
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-booked" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      lead.status_id === 3 ||
                                      lead.status_id === 6
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-closed" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      lead.status_id === 4 ||
                                      lead.status_id === 8
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-ncover" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      lead.status_id === 5
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-rtbook" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "leads" }
                  })
                ],
                2
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-0" }, [
      _c("label", [_vm._v("ADDITIONAL CONTACTS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "fa fa-plus", attrs: { "aria-hidden": "true" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21e57976", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21e57976","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customers/CustomersEdit.vue
// module id = null
// module chunks = 